import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`How two oceans united in the Early Cretaceous`}</h2>
    <p><img parentName="p" {...{
        "src": "/reevesdotnl/d976429a755ae05335569f943f1eefea/sri-2-2.gif",
        "alt": "Sri Lanka leaves India, then Antarctica - the animation may take a few second to load"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Our model has the plate circuit through East Gondwana closing between India and Madagascar.  There is no evidence for dsiruption in East Gondwana before Cretaceous
times so the model keeps the relative position of India and Madagascar constant as long as possible. In practice, there is little room between accepted positions for
Madagascar against Africa and Antarctica against Africa for the creation of additional space between India and Madagascar until India starts to separate from
Antarctica.  We place this event at about the start of Cretaceous time (142.3 Ma; M18 to be precise).`}</p>
    <p>{`The space available to Sri Lanka to become a separate tectonic fragment is always limited and a defensible history of separation has to conform with geological
observation in the Mannar Strait, offshore India and Sri Lanka. The animation illustrates the best attempt to achieve this so far. Initial opening is between
Sri Lanka and India. The conjugate margins between India and Antarctica along the Coromandel Coast start to separate with oblique dextral strike-slip that develops
into a long-offset transform bringing the westward-growing ridge between India and Antarctica south to between India and Sri Lanka, eventually to join up with the
long-established spreading in the Africa-Antarctica Corridor (AAC) at about 130 Ma (Hauterivian).`}</p>
    <p>{`Initial dextral strike-slip between Sri Lanka and Antarctica first separates Sri Lanka from Antarctica's Gunnerus Ridge and then the active ridge steps southwards
and evolves progressively into an active new ridge between Sri Lanka and Antarctica. Activity on the ridge in the Mannar Strait between India and Sri Lanka
progressively dies out as Sri Lanka becomes firmly a part of the India plate. Note the acceleration of events at about 125 Ma as Antarctica swings clockwise away
from Africa and takes on a new direction. The animation ends at 96 Ma but this mode of separation continues until about 90 Ma and can be
confirmed from the excellent match of conjugate fractures zones up till about 90 Ma when major changes pre-date India's eventual rapid departure to the northwest,
away from Madagascar. These later developments may be followed in other, more regional, animations.`}</p>
    <p>{`The geological maps are courtesy of the Gondwana Map Project (IGCP-628) at the Federal University of Rio de Janeiro.`}</p>
    <p>{` `}<em parentName="p">{`Last update: 2025 October 3`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      